import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

/**
 * Shared skeleton loader for Banner, Dealer, Dealer Billing, and Schedule cards.
 * Renders a simple skeleton that fills its container so card size stays constant when loading.
 */
const CardLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="100%"
      viewBox="0 0 300 230"
      preserveAspectRatio="none"
      backgroundColor={theme.colors.surface}
      foregroundColor={theme.colors.primary.variant6}
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      <rect x="0" y="12" rx="6" ry="6" width="80%" height="16" />
      <rect x="0" y="40" rx="6" ry="6" width="100%" height="72" />
      <rect x="0" y="124" rx="6" ry="6" width="90%" height="72" />
      <rect x="0" y="208" rx="6" ry="6" width="60%" height="14" />
    </ContentLoader>
  );
};

export default CardLoader;
